import { render, staticRenderFns } from "./TransferenciaSaldo.vue?vue&type=template&id=aceec040&"
import script from "./TransferenciaSaldo.vue?vue&type=script&lang=js&"
export * from "./TransferenciaSaldo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports